"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const domainSchema = new mongoose_1.Schema({
    project: {
        ref: "Project",
        type: mongoose_1.Schema.Types.ObjectId,
        required: false,
    },
    name: {
        type: String,
        required: true,
        unique: true,
    },
    team_id: {
        ref: "Team",
        type: mongoose_1.Schema.Types.ObjectId,
        required: false
    },
    user_id: {
        ref: "User",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    primary: {
        type: Boolean,
        default: false,
    },
    is_discounted: {
        type: Boolean,
        default: false,
    },
    auto_renewal: {
        type: Boolean,
        default: false,
    },
    privacy_enabled: {
        type: Boolean,
        default: false,
    },
    renewal_date: {
        type: String,
        required: false,
    },
    renewal_price: {
        type: Number,
        required: false,
    },
    preview: {
        ref: "Preview",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    subscription: {
        ref: "Subscription",
        type: mongoose_1.Schema.Types.ObjectId,
    },
    nameservers: {
        type: Array,
        required: false,
    },
    purchased: {
        type: Boolean,
        default: false,
    },
    trigger_created: {
        type: Boolean,
        default: false,
    },
    trigger_created_at: {
        type: String,
    },
    job_identifier: {
        type: String,
    },
    dns: [
        {
            ref: "Dns",
            type: mongoose_1.Schema.Types.ObjectId,
        },
    ],
    is_pending_verification: Boolean,
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("Domain", domainSchema);
